import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'gatsby';
import { getIcon } from '../../utils';
import Icon from '../Icon';
import * as styles from './Search.module.scss';
import {
  search,
  search__icon,
  search__input,
  search__input__inner,
  search__times,
  search__ul,
  search__ul_li,
  search__ul_li_a
} from './Search.module.scss';
import { toggleDrawer as toggleDrawerAction } from '../../state/app';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: '',
      results: []
    };
  }

  render() {
    console.log(styles);
    return (
      <div className={search}>
        <input className={search__input} placeholder="キーワード" type="text" value={this.state.query} onChange={this.search} />
        <span className={search__icon}>
            <Icon icon={getIcon('search')} />
        </span>
        { this.state.query
          ? <a className={search__times} onClick={this.reset}>
            <Icon icon={getIcon('times')} />
        </a> : '' }
        <ul className={search__ul}>
          {this.state.results.map((result) => (
            <li className={search__ul_li} key={result.ref}>
              <Link className={search__ul_li_a} to={`/${result.slug}`} onClick={() => this.props.toggleDrawer(false)}>
                {result.title}
              </Link>
            </li>))
          }
        </ul>
      </div>
    );
  }

  getSearchResults(query) {
    if (!query || !window.__LUNR__) return [];
    const lunrJpIndex = window.__LUNR__['jp'];
    // 部分一致で検索する
    const searchResult = lunrJpIndex.index.search(`*${query}*`);
    return searchResult.map(({ ref }) => ({
      ...lunrJpIndex.store[ref],
      ref
    }));
  }

  reset = () => {
    this.setState({
      query: '',
      results: []
    });
  }

  search = (event) => {
    const query = event.target.value;
    const results = this.getSearchResults(query);
    this.setState({
      results,
      query
    });
  };
}

export default connect(
  (state) => ({ isDrawerOpen: state.app.isDrawerOpen }),
  (dispatch) => ({ toggleDrawer: (open) => dispatch(toggleDrawerAction(open)) }),
)(Search);